import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { trim } from 'lodash';
import { fDate } from 'src/utils/format-time';
import Iconify from '../iconify';

export const UserNotesTooltip = ({ notesData = {} }) => {
  const { updated_at, org_user_notes_last_updated_by, notes } = notesData;
  const notesUpdatedBy = `${org_user_notes_last_updated_by?.first_name} ${org_user_notes_last_updated_by?.last_name}`;
  const notesUpdatedDate = fDate(updated_at);

  return (
    <Tooltip
      title={
        <Stack>
          <Typography variant={'subtitle2'}>Notes:</Typography>
          <Typography variant={'body2'} gutterBottom>
            {trim(notes)}
          </Typography>
          <Typography variant={'caption'}>
            {notesUpdatedBy ? `${notesUpdatedBy} | ${notesUpdatedDate}` : ''}
          </Typography>
        </Stack>
      }
    >
      <Chip
        label={notes?.length > 20 ? notes?.slice(0, 20) + '...' : notes}
        variant="outlined"
        // size="small"
        icon={<Iconify icon="solar:notes-bold" width={24} />}
      />
    </Tooltip>
  );
};
